import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FileService } from '../../../../services/file.service';
import { UiServices } from '../../../../services/ui-services';
import { PopoverTagsComponent } from '../../../../components/popover-tags/popover-tags.component';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../../../../services/http.service';
import { environment } from 'src/environments/environment';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.scss'],
})
export class CreateCategoryComponent implements OnInit {
  @ViewChild('badge', { static: true }) badge;
  @Input() edit;
  @Input() type;
  banner: string;
  image: string;

  imageFile: File;
  tags = [];
  catalogueForm: UntypedFormGroup;
  url = environment.url;
  littleImageFile: File
  littleImagesUploaded: any;
  slidesImagesCatalogue: any[] = [];
  domainId = environment.domainId;

  constructor(
    private fileService: FileService,
    private uiSv: UiServices,
    private fb: UntypedFormBuilder,
    private httpService: HttpService,
    private renderer: Renderer2,
    private modalController: ModalController,
    private translateSv: TranslateService
  ) { }

  async ngOnInit() {
    
    this.catalogueForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      title: ['', Validators.required],
      isSalient: [false],
      domainId: [this.domainId]
    });

    if(this.edit){
      this.banner = this.edit.banner;
      this.image = this.edit.file;
      await this.uiSv.showLoading();
      this.edit.type = 'catalogues'
      this.slidesImagesCatalogue = this.edit.media;
      this.tags = this.edit.tags.split(' ');
      this.catalogueForm.patchValue(this.edit);
      await this.uiSv.loading.dismiss();
    }
  }

  async createCatalogue(){
    try{
      const formData = new FormData();
      this.catalogueForm.value.tags = this.tags.join(' ');
      for(let key of Object.keys(this.catalogueForm.value)){
        const value = this.catalogueForm.value[key];
        formData.set(key, value);
      }

      formData.set('banner', this.imageFile);
      formData.set('image', this.littleImageFile);
      for(const img of this.slidesImagesCatalogue){
        formData.append('images', img.file);
      }

      await this.uiSv.showLoading();
      if(this.edit){
        formData.set('id', this.edit.id);
        await this.httpService.itemAction(formData, 'catalogue','update');
        await this.modalController.dismiss();
        const translate = this.translateSv.instant('CATALOGO_EDITADO_EXITOSAMENTE');
        await this.uiSv.showToast(translate);
      }else{
        await this.httpService.itemAction(formData, 'catalogue','store');
        await this.modalController.dismiss();
        const translate = this.translateSv.instant('CATALOGO_CREADO_EXITOSAMENTE');
        await this.uiSv.showToast(translate);
      };
      await this.uiSv.loading.dismiss();
    }catch (err){
      await this.uiSv.loading.dismiss();
      this.catalogueForm.markAllAsTouched();
      if(err.error.error){
        this.uiSv.showToast(err.error.error);
      }
      // 'Verifica que los campos estén completos.'
    }
    
  }

  deleteImage(file){
    this.slidesImagesCatalogue = this.slidesImagesCatalogue.filter(x => x.file !== file);
  }

  setImages(ev){
    
    if(ev.type === 'banner'){
      this.imageFile = ev.file;
    }else{
      this.littleImageFile = ev.file
    }
  }

  showTags(){
    this.uiSv.showPopover(PopoverTagsComponent, {tags: this.tags});
  }

  setAnimBadge(tagInput){
    const res = this.fileService.setAnimBadge(tagInput, this.badge, this.tags);
    if(!res) return;
    this.renderer.addClass(this.badge.el, 'showBadge');
    setTimeout(() => {
      this.renderer.removeClass(this.badge.el, 'showBadge')
    }, 1000)
  }
}
